import axios from "axios";
import { config } from "../../Network_Calls/config";

const getContactDossier = async (implId, id) => {
  const response = await axios.post(
    process.env.REACT_APP_SERVER_URL + "/dossier/getContactDossier",
    { implId: implId || null, id: id || null },
    {
      ...config(),
    }
  );
  return response;
};

const postContactDossierStep = async (implId, id, step, data) => {
  const response = await axios.post(
    process.env.REACT_APP_SERVER_URL + "/dossier/postContactDossierStep",
    { implId: implId || null, id: id || null, step, data },
    {
      ...config(),
    }
  );
  return response;
};

const postContactDossierFinal = async (implId, id, form) => {
  const response = await axios.post(
    process.env.REACT_APP_SERVER_URL + "/dossier/postContactDossierFinal",
    { implId: implId || null, id: id || null, form },
    {
      ...config(),
    }
  );
  return response;
};

export {
  getContactDossier,
  postContactDossierStep,
  postContactDossierFinal,
};